export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13345.35e85888.jpg";